// ConfigAlarmas.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Grid, Backdrop, CircularProgress
} from '@mui/material';
import { UrlApi } from '../../../services/apirest';

export default function ConfigAlarmas({ open, onClose, onSave }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    // 1) al abrir modal cargo config
    useEffect(() => {
        if (!open) return;
        (async () => {
            setLoading(true);
            try {
                const { data } = await axios.get(`${UrlApi}/scada/tanques-info`);
                setItems(data);
            } catch (err) {
                console.error('Error fetching config:', err);
            } finally {
                setLoading(false);
            }
        })();
    }, [open]);

    // 2) manejar cambios
    const handleChange = (idx, field, val) => {
        setItems(curr =>
            curr.map((it, i) => i === idx
                ? { ...it, [field]: val }
                : it
            )
        );
    };

    // 3) guardar (PUT uno a uno)
    const handleGuardar = async () => {
        setLoading(true);
        try {
            await Promise.all(items.map(it =>
                axios.put(
                    `${UrlApi}/scada/tanques-info/${it.id}`,
                    {
                        nombre: it.nombre,
                        producto: it.producto,
                        max: it.max,
                        alertaBajo: it.alertaBajo,
                        alertaAlto: it.alertaAlto
                    },
                    { headers: { 'Content-Type': 'application/json' } }
                )
            ));
        } catch (err) {
            console.error('Error saving config items:', err);
        } finally {
            setLoading(false);
            onSave(items);  // paso nuevos valores al padre
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Configuración Alarmas</DialogTitle>
            <DialogContent dividers>
                {loading && (
                    <Backdrop open sx={{ color: '#fff', zIndex: t => t.zIndex.drawer + 1 }}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                )}
                <Grid container spacing={2}>
                    {items.map((it, idx) => (
                        <React.Fragment key={it.id}>
                            <Grid item xs={4}>
                                <TextField
                                    label="Nombre"
                                    value={it.nombre}
                                    disabled
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Bajo %"
                                    type="number"
                                    value={it.alertaBajo}
                                    onChange={e => handleChange(idx, 'alertaBajo', parseFloat(e.target.value))}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Alto %"
                                    type="number"
                                    value={it.alertaAlto}
                                    onChange={e => handleChange(idx, 'alertaAlto', parseFloat(e.target.value))}
                                    fullWidth
                                />
                            </Grid>
                        </React.Fragment>
                    ))}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleGuardar}>Guardar</Button>
            </DialogActions>
        </Dialog>
    );
}
